import { Link } from "react-router-dom";
import "../css/Footer.css";
import { FaEnvelope } from "react-icons/fa";

function Footer() {
  return (
    <footer className="app-footer footer" data-testid="app-footer">
      <div className="app-shell footer-container">
        <div className="footer-brand">
          <img
            src={`${process.env.PUBLIC_URL}/static/logo.svg`}
            className="footer-logo"
            alt=""
          />
          <div className="footer-text">
            <p className="footer-subtitle">
              Psy-Trainer — безопасное пространство для оценки вашего состояния и отслеживания прогресса.
            </p>
          </div>
        </div>

        <div className="footer-links">
          <Link to="/contacts">Контакты</Link>
          <a href="mailto:contact@psy-trainer.ru">
            <FaEnvelope /> contact@psy-trainer.ru
          </a>
        </div>

        <div className="footer-copy">
          © {new Date().getFullYear()} Psy-Trainer. Все права защищены.
        </div>
      </div>
    </footer>
  );
}

export default Footer;
